import React, { useState, useEffect } from 'react';
import { Button, Input } from "reactstrap";
import { toastr } from 'react-redux-toastr';
import { CspModal, CspModalHeader, CspModalBody, CspModalFooter } from "../CspModal";
import general_fetch from "../../utils/fetch";
import country_list from '../../utils/country_list';

const CREATE_ORG_ERRORS = {
    SIGNUP_LIMIT_REACHED: 'This email already owns a business org',
    MISSING_PARAMS: 'Org name, owner email and country are required',
    UNAUTHORIZED_ACCESS: 'Only Customer Success Admins can create orgs',
};

// ST-4042: CS admins create orgs for customers; the owner gets a set-password invite from the backend.
const CreateOrgModal = ({ open, toggle, set_page_loader, on_created }) => {
    const [name, set_name] = useState('');
    const [owner_email, set_owner_email] = useState('');
    const [owner_first_name, set_owner_first_name] = useState('');
    const [owner_last_name, set_owner_last_name] = useState('');
    const [country, set_country] = useState('IN');

    useEffect(() => {
        if (open) {
            set_name('');
            set_owner_email('');
            set_owner_first_name('');
            set_owner_last_name('');
            set_country('IN');
        }
    }, [open]);

    const create_org = async () => {
        try {
            if (set_page_loader) set_page_loader(true, 'Creating org...');
            let resp = await general_fetch({ url: 'csp/create_org', body: { name, owner_email, owner_first_name, owner_last_name, country }, req_resp: true });
            if (set_page_loader) set_page_loader(false);
            if (resp && resp.response_code === 1) {
                toastr.success(resp.data.invite_sent ? `Org created, set-password invite sent to ${owner_email.trim()}` : 'Org created; no set-password invite was sent (the owner already has a login, or the mail failed)');
                toggle();
                if (on_created) on_created(resp.data);
            } else {
                toastr.error(CREATE_ORG_ERRORS[resp && resp.code] || (resp && resp.message) || 'Could not create the org');
            }
        } catch (err) {
            if (set_page_loader) set_page_loader(false);
            console.error('create_org failed', err);
            toastr.error('Could not create the org');
        }
    };

    const valid = name.trim() && owner_email.trim() && country;

    return (
        <CspModal open={open} toggle={toggle} size="md">
            <CspModalHeader title="Create Org" toggle={toggle} />
            <CspModalBody>
                <label className="form-control-label mb-3 col-12">
                    Org Name*:
                    <Input className="form-control-alternative" type="text" value={name} onChange={(e) => set_name(e.target.value)} />
                </label>
                <label className="form-control-label mb-3 col-12">
                    Owner Email*:
                    <Input className="form-control-alternative" type="email" value={owner_email} onChange={(e) => set_owner_email(e.target.value)} />
                </label>
                <label className="form-control-label mb-3 col-6">
                    Owner First Name:
                    <Input className="form-control-alternative" type="text" value={owner_first_name} onChange={(e) => set_owner_first_name(e.target.value)} />
                </label>
                <label className="form-control-label mb-3 col-6">
                    Owner Last Name:
                    <Input className="form-control-alternative" type="text" value={owner_last_name} onChange={(e) => set_owner_last_name(e.target.value)} />
                </label>
                <label className="form-control-label mb-3 col-12">
                    Country*:
                    <Input className="form-control-alternative" type="select" value={country} onChange={(e) => set_country(e.target.value)}>
                        {country_list.map((c, idx) => (
                            <option key={idx} value={c.code}>{c.name}</option>
                        ))}
                    </Input>
                </label>
            </CspModalBody>
            <CspModalFooter>
                <Button color="secondary" onClick={toggle} className="mr-2">Cancel</Button>
                <Button color="primary" onClick={create_org} disabled={!valid}>Create Org</Button>
            </CspModalFooter>
        </CspModal>
    );
};

export default CreateOrgModal;
